<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>追加機能権限一覧</h5>
      </div>
      <div class="col-3">
        <button id="createRoleBtn" type="button" class="btn-sm btn-outline-info" v-on:click="create">新しく登録する</button>
      </div>
    </div>
    <div id="main" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <table class="table table-dark table-sm table-hover">
          <thead>
            <tr>
              <th scope="col" style="width:70px">#</th>
              <th scope="col">名称</th>
              <th scope="col" style="width:150px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(role, index) in roles" v-bind:key="role.id">
              <th scope="row">{{ currentIndex * limit + index + 1 }}</th>
              <td>{{ role.roleName }}</td>
              <td>
                <button type="button" class="btn-sm btn-light" v-on:click="modify(role.id)">編集する</button>
              </td>
            </tr>
          </tbody>
        </table>
        <nav aria-label="pager">
          <ul class="pagination justify-content-center">
            <li v-if="isPrev" v-on:click="goPrev">
              <a class="btn page-link rounded-pill">&larr; 前</a>
            </li>
            <li v-if="isPrev||isNext" class="mx-2">
              <a class="btn page-link rounded-pill">現在</a>
            </li>
            <li v-if="isNext" v-on:click="goNext">
              <a class="btn page-link rounded-pill">次 &rarr;</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-4">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Index',
  mixins: [sessions,path,headers],
  props: ['realms'],
  data: function () {
    return {
      roles: [],
      message: '',
      gridCount: 0,
      currentIndex: 0,
      limit: 20,
    }
  },
  mounted() {
    if(this.$store.getters.hospital.id !==0){
      this.search(true)
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.search(true)
        }
      }
    )
  },
  computed: {
    isNext: function () {
      return this.gridCount === this.limit
    },
    isPrev: function () {
      return this.currentIndex !== 0
    },
    isMessage: function () {
      return this.message.length > 0
    }
  },
  methods: {
    create() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/role/create'))
    },
    modify(id) {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/role/modify/'+id))
    },
    goNext(){
      this.currentIndex++
      this.search(false)
    },
    goPrev(){
      this.currentIndex--
      this.search(false)
    },
    search(isInit) {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          if(isInit){
            this.currentIndex = 0
          }
          var offset = this.currentIndex * this.limit
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          axios.get("/api/role/list/" + hospitalId + '/' + offset, {
            headers: this.headers(accessToken)
          }).then(response => {
            this.roles = response.data.data.roles;
            this.gridCount = this.roles.length
          })
          .catch(err => {
            this.message = err.message
          })
        } else {
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
        }
      }).catch(err => {
        this.message = err.message
      })
    }
  }
}
</script>
<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#main {
  height: 100%;
}
#createRoleBtn {
  float:right;
}
.btn-sm{
  margin-left: 5px;
}
.search-solid{
  cursor: pointer;
  height: 18px;
  width: 18px;
}
.sort-solid{
  height: 25px;
  width: 25px;
  margin-right: 10px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>